var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfeInvoiceReview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #0071cd;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.25,3.97l-3.08-3.13c-.2-.2-.47-.31-.75-.31H3.78c-.73,0-1.33.6-1.33,1.33v11.29c0,.73.6,1.33,1.33,1.33h7.43c.73,0,1.33-.6,1.33-1.33V4.7c0-.28-.11-.54-.3-.73ZM11.76,13.14c0,.3-.24.54-.54.54H3.78c-.3,0-.54-.24-.54-.54V1.86c0-.3.24-.54.54-.54h4.57v2.72c0,.29.24.53.53.53h2.82s.05.09.05.14v8.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.43,4.14h2.66c.22,0,.39-.18.39-.39s-.18-.39-.39-.39h-2.66c-.22,0-.39.18-.39.39s.18.39.39.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.49,5.58c0-.22-.18-.39-.39-.39h-2.66c-.22,0-.39.18-.39.39s.18.39.39.39h2.66c.22,0,.39-.18.39-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.96,8.63h.96c.24,0,.43.19.43.44s.19.44.43.44.43-.2.43-.44c0-.73-.57-1.32-1.28-1.32h0v-.44c0-.24-.19-.44-.43-.44s-.43.2-.43.44v.44h-.11c-.65,0-1.17.54-1.17,1.2,0,.3.07.56.24.77.16.2.38.31.56.37l1.55.53c.12.04.16.08.17.09,0,0,.04.05.04.22,0,.18-.14.32-.32.33h-.96c-.24,0-.43-.19-.43-.44s-.19-.44-.43-.44-.43.2-.43.44c0,.73.57,1.32,1.28,1.32h0v.44c0,.24.19.44.43.44s.43-.2.43-.44v-.44h.11c.65,0,1.17-.54,1.17-1.2,0-.3-.07-.56-.24-.77-.16-.2-.38-.31-.56-.37l-1.55-.53c-.12-.04-.16-.08-.17-.09,0,0-.04-.05-.04-.22,0-.18.14-.32.32-.33Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfeInvoiceReview);
export default __webpack_public_path__ + "static/media/AFE Invoice Review.71f631820ee7827797ea60330fb6da38.svg";
export { ForwardRef as ReactComponent };